"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHEventHandler = void 0;
class KHEvent {
    constructor(name) {
        this.name = name;
        this.callbacks = [];
    }
    registerCallback(cb) {
        this.callbacks.push(cb);
    }
    unregisterCallback(cb) {
        let idx = this.callbacks.indexOf(cb);
        if (idx < 0)
            return;
        this.callbacks.splice(idx, 1);
    }
    emitEvent(data) {
        this.callbacks.forEach(function (callback) {
            callback(data);
        });
    }
}
class KHEventHandler {
    constructor(defaultEvents = []) {
        this.events = {};
        for (let i = 0, n = defaultEvents.length; i < n; i++) {
            this.addEvent(defaultEvents[i]);
        }
    }
    addEvent(name) {
        this.events[name] = new KHEvent(name);
    }
    emitEvent(name, args = null) {
        if (!(name in this.events)) {
            console.trace("Unregistered event name: " + name);
            return;
        }
        this.events[name].emitEvent(args);
    }
    registerCallback(name, cb) {
        if (!(name in this.events)) {
            console.trace("Unregistered event name: " + name);
            return;
        }
        this.events[name].registerCallback(cb);
    }
    unregisterCallback(name, cb) {
        if (!(name in this.events)) {
            console.log("Unregistered event name: " + name);
        }
        this.events[name].unregisterCallback(cb);
    }
}
exports.KHEventHandler = KHEventHandler;
